module.exports = __webpack_public_path__ + "static/media/start.5c0d40d6.wav";